<template>
  <div id="about__assessoria" class="about-infantil fade-in-up pb-4">
    <div id="header">
      <div class="img__header">
        <div class="bg__escuro"></div>
        <div class="bg__title">
          <b-container fluid="lg">
            <h2 class="text-title">Assessoria Pedagógica</h2>
          </b-container>
        </div>
      </div>
    </div>

    <BreadSistema />

    <b-container fluid="lg" class="pt-4 pb-4">
      <div class="box-text">
        <div class="content-text">
          <p class="lead font-weight-light">Com a finalidade de fazer um acompanhamento personalizado com cada um dos
            parceiros, oferecemos capacitação e atendimento durante todo o ano.</p>
          <p class="mt-3">Além disso, nossa equipe soluciona dúvidas inerentes ao uso do material de forma ágil e está
            disponível para reuniões presenciais.</p>
          <h5 class="font-weight-bolder mt-4">Módulo do Professor</h5>
          <p>
            O professor recebe um Manual de Orientações e sugestões para a condução das aulas e aprofundamento de cada
            tema. São propostas de trabalhos, atividades extras, leituras e gabaritos.
          </p>
          <h5 class="font-weight-bolder mt-4">Módulo do Coordenador</h5>
          <p>
            O coordenador de cada nível recebe um caderno de Programações, para auxiliar sua equipe a fazer o
            Planejamento Pedagógico semestral ou anual.
          </p>
          <h5 class="font-weight-bolder mt-4">Aulas Digitais</h5>
          <p>
            Os professores contam com mais esse apoio: apresentações prontas, com os temas abordados nas coleções, que
            podem ser baixadas do site do Sistema e adequadas às necessidades da turma.
          </p>
          <hr>
          <div class="d-block mx-auto">
            <h5 class="text-center font-weight-bolder text-uppercase">Para mais informações</h5>
            <p class="text text-center">
              Para mais informações sobre esse material, solicite hoje um consultor do Sistema de Ensino CPV.
            </p>
            <div class="d-flex justify-content-center">
              <b-button class="btn__consultor" :to="{ name: 'escolaParceira' }" variant="transparent">
                <i class="fa-regular fa-messages"></i>
                <span>Fale com um consultor</span>
              </b-button>
            </div>
          </div>
        </div>
      </div>
    </b-container>
  </div>
</template>

<script>
import axios from 'axios';
import { required, minLength, email } from 'vuelidate/lib/validators';

export default {
  name: 'AsseroriaPedagogica',
  metaInfo: { title: 'Assessoria Pedagógica' },
  components: { BreadSistema: () => import('../GlobalComponents/bread-sistema.vue') },
  validations: {
    nome: { required, minLength: minLength(3) },
    email: { required, email },
    celular: { required, minLength: minLength(15) },
    aceiteWhatts: { required },
    cargo: { required },
  },
  data: () => {
    return {
      spin: false,

      nome: '',
      email: '',
      celular: '',
      aceiteWhatts: '',
      cargo: '',
      outro: '',
      outroEsp: '',

      submitted: false,
      error: '',

      assessoria: {
        data: [],
      },
      optionAceite: [{ name: 'Sim' }, { name: 'Não' }],
      cargos: [
        { name: 'Diretor(a)' },
        { name: 'Coordenador(a)' },
        { name: 'Professor(a)' },
        { name: 'Mantenedor(a)' },
        { name: 'Outro' },
      ],
    };
  },
  mounted: () => { },
  computed: {
    nameState() {
      if (this.$v.nome.$pending) return null;
      return !this.$v.nome.$error && this.nome.length > 2;
    },
    emailState() {
      if (!this.email) return null;
      if (this.$v.email.$pending) return null;

      return !this.$v.email.$error;
    },

    celularState() {
      if (!this.celular) return null;
      if (this.$v.celular.$pending) return null;
      return !this.$v.celular.$error;
    },

    aceiteWhatsState() {
      if (!this.aceiteWhatts) return null;
      if (this.$v.aceiteWhatts.$pending) return null;

      return !this.$v.aceiteWhatts.$error;
    },
    cargoState() {
      return !!this.cargo || this.$v.cargo.$error;
    },
  },
  methods: {
    formatterEmail(value) {
      return value.toLowerCase();
    },

    handleSubmit(e) {
      this.spin = true;
      this.submitted = true;
      this.$v.$touch();

      let validation = this.$v.$invalid;

      if (validation) {
        setTimeout(() => {
          this.spin = false
        }, 1500)
        return;
      }

      this.postData()
    },

    postData() {
      axios.post('v1/assessoriaPedagogica', {
        nome: this.nome,
        email: this.email,
        celular: this.celular,
        aceiteWhatts: this.aceiteWhatts,
        cargo: this.cargo,
        outro: this.outro,
        outroEsp: this.outroEsp,
        protocolo: this.protocolo(),
      })
        .then((response) => {
          this.assessoria = response;
        })
        .catch(function (error) {
          console.log(error)
        })
        .finally(() => {
          let oNome = this.nome;
          let tmp = oNome.split(' ');
          oNome = tmp[0];

          this.spin = false;
          // this.$router.push({
          //   name: 'thanks',
          //   params: {
          //     nome: oNome,
          //   },
          // });
        });
    },

    protocolo: function () {
      var data = new Date();
      return (
        ('0' + data.getDate()).substr(-1) +
        ('0' + (data.getMonth() + 1)).substr(-1) +
        data.getFullYear() +
        Math.floor(1000 + Math.random() * 9000)
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.fade-in-up {
  -webkit-animation: fadeIn 0.4s ease-in-out;
  -moz-animation: fadeIn 0.4s ease-in-out;
  -o-animation: fadeIn 0.4s ease-in-out;
  animation: fadeIn 0.4s ease-in-out;
}

#about__assessoria {
  background-color: #ffffff;

  #header {
    .img__header {
      background-image: url('https://app-sistemacpv.s3.amazonaws.com/images/about.jpeg');
      background-repeat: no-repeat;
      background-position: top center;
    }
  }

  h5 {
    color: #3a1c53;
    font-family: 'Clan OT', sans-serif;
  }

  p {
    font-size: 16px;
    line-height: 22px;
  }

  .lead {
    font-size: 20px;
    line-height: 26px;
    padding: 0;
    margin: 0;
  }

  .btn__consultor {
    display: inline-flex;
    min-width: auto;
    min-height: auto;

    margin: 0px auto 0;
    padding: 8px 16px;

    gap: 6px;

    background-color: #e98b24;
    border: 1px solid #e98b24;
    border-radius: 5px;

    display: flex;
    align-items: center;

    font-size: 14px;
    line-height: 20px;

    color: #fdf3e9;

    .icon {
      width: 18px;
      height: 18px;

      display: flex;
      align-items: center;

      i {
        font-size: 14px;
        line-height: 20px;
      }
    }

    &:hover {
      background-color: #d27d20;
      transition: all 0.3s ease-in-out;
      border: 1px solid #d27d20;
    }
  }
}

@media screen and (min-width: 1200px) {
  .content-text {
    padding-left: 32px;
    padding-right: 32px;
  }
}

@media screen and (min-width: 320px) and (max-width: 1200px) {
  .content-text {
    padding-left: 16px;
    padding-right: 16px;
  }
}
</style>
